"use strict";
// implementations
var api_date_information_model_1 = require("./api-date-information.model");
exports.DateInformation = api_date_information_model_1.DateInformation;
var api_date_parts_model_1 = require("./api-date-parts.model");
exports.DateParts = api_date_parts_model_1.DateParts;
//# sourceMappingURL=D:/a/1/s/base/src/models/date-models/api-dates.module.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/src/models/date-models/api-dates.module.js